import "./featureinfo.scss";

import { Card } from "@amzn/stencil-react-components/card";
import { Chip, ChipBackgroundColor, ChipSize } from "@amzn/stencil-react-components/chip";
import { Expander, ExpanderTitleRendererParams } from "@amzn/stencil-react-components/expander";
import { Hr, Row, Spacer, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { getString } from "common/uistringlabels/uiStringUtils";
import parse from "html-react-parser";
import React, { FC } from "react";

const TIME_CONSTANTS = {
  DAYS_IN_WEEK: 7,
  HOURS_IN_DAY: 24,
  MINUTES_IN_HOUR: 60,
  SECONDS_IN_MINUTE: 60,
  MILLISECONDS_IN_SECOND: 1000,
};

const WEEK_IN_MILLISECONDS =
  TIME_CONSTANTS.DAYS_IN_WEEK *
  TIME_CONSTANTS.HOURS_IN_DAY *
  TIME_CONSTANTS.MINUTES_IN_HOUR *
  TIME_CONSTANTS.SECONDS_IN_MINUTE *
  TIME_CONSTANTS.MILLISECONDS_IN_SECOND;

interface FeatureInfoProps {
  title: string;
  description: string;
  date: string;
  index: number;
}

const FeatureInfo: FC<FeatureInfoProps> = ({ title, description, date, index }) => {
  const isNew = () => {
    const featureDate = new Date(date);
    const now = new Date();
    const weekAgo = new Date(now.getTime() - WEEK_IN_MILLISECONDS);
    return featureDate > weekAgo;
  };

  const renderTitle = (props: ExpanderTitleRendererParams) => {
    return (
      <Row style={{ justifyContent: "space-between", alignItems: "flex-start", width: "100%" }} onClick={props.toggle}>
        <Row>
          {isNew() && (
            <Chip size={ChipSize.ExtraSmall} backgroundColor={ChipBackgroundColor.Green}>
              <Text>{getString("aiForMe.whatsNew.new")}</Text>
            </Chip>
          )}
          <Text fontSize={"T300"}>{props.titleText}</Text>
        </Row>
        <Text>{new Date(date).toLocaleString("default", { day: "2-digit", month: "long", year: "numeric" })}</Text>
      </Row>
    );
  };

  return (
    <View key={index} data-test-id={`feature-${index}`} style={{ marginTop: "16px" }}>
      <View style={{ marginBottom: "16px" }}>
        <Expander titleText={title} renderTitle={renderTitle} shouldExpandOnMount={isNew()}>
          {parse(description)}
        </Expander>
      </View>
      <Hr />
    </View>
  );
};

export default FeatureInfo;
